// extracted by mini-css-extract-plugin
export default {"ErrorPage":"ErrorPage_ErrorPage__um8aO","Quote":"ErrorPage_Quote__f0IL0","LogoImage":"ErrorPage_LogoImage__4ZgMh"};